<div style="margin-top: 10px">
    <div class="row action-toolbar">
        <div class="col-12">
            <form class="form-inline">
                <div class="input-header-group">
                    <span class="input-header">Select Department</span>
                    <wj-combo-box
                        id="selectedDept"
                        style="width: 250px"
                        [(ngModel)]="selectedDept"
                        name="selectedDept"
                        [itemsSource]="departments()"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>

                @if (unallocatedHours > 1) {
                    <span style="padding-top: 4px">
                        <b>{{ unallocatedHours | number: '1.0-0' }}</b> hours remain to be allocated in the Records tab.
                    </span>
                }
            </form>
        </div>
    </div>
    <div class="row">
        @if (chartData) {
            <div class="col-12">
                <wj-flex-chart
                    appAutoSize
                    [itemsSource]="chartData.points"
                    [bindingX]="'label'"
                    [chartType]="chartData.chartType"
                    [header]="chartData.title"
                    [stacking]="chartData.stacking"
                    [legendToggle]="true"
                >
                    <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                    <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'Hours'" [format]="'N0'" [min]="0"></wj-flex-chart-axis>
                    @for (serie of chartData.series; track serie.binding) {
                        <wj-flex-chart-series [binding]="serie.binding" [name]="serie.name" [chartType]="serie.chartType">
                        </wj-flex-chart-series>
                    }
                </wj-flex-chart>
            </div>
        }
    </div>
</div>
